import { cn } from '@/lib/utils'

export function Skeleton({ className }: { className?: string }) {
  return (
    <div className={cn('rounded-md bg-Stroke-default/50 motion-safe:animate-pulse', className)} />
  )
}
